import React, { useState } from "react";
import "./style.scss";
import { formatQuesNumber } from "../../../../functions/common";
import SubmitFormPopup from "./partials/submitModal";
import complete from '../../../../assets/images/svgs/completed.svg'
import { Link } from "react-router-dom";

const getUnansweredQuestions = ({
  requiredQuestions,
  answersDone,
  parsedQuestions,
}) => {
  let questions = [];
  requiredQuestions?.forEach((v) => {
    if (!answersDone?.[v]) {
      questions.push(parsedQuestions?.find((ques) => ques?.refCode === v));
    }
  });
  return questions;
};

const ShowSubmit = ({
  requiredQuestions,
  answersDone,
  parsedQuestions,
  selectQuestion,
  handleNext,
  isSubmitted,
  assesmentAndLocation,
  setShowInstructions,
  isSolelyManaged
}) => {
  const unansweredQuestions = getUnansweredQuestions({
    requiredQuestions,
    answersDone,
    parsedQuestions,
    assesmentAndLocation
  });
  const [showModal, setShowModal] = useState(false);

  const handleSelect = (refCode) => {
    const index = parsedQuestions.findIndex((v) => v?.refCode === refCode);
    selectQuestion(index);
  };

  const closeModal = () => setShowModal(false);
  const openModal = () => setShowModal(true);
  // eslint-disable-next-line eqeqeq
  const isAllRequiredFilled = unansweredQuestions?.length != 0;

  const showInstruction = () => setShowInstructions(true);

  return (
    <div className={`${isSubmitted ? 'submitted__ques':""} show__submit__question`}>
      {isSubmitted ?
        <div className="instructions__section">
          <>
            <div className="d-flex justify-content-center">
              <img src={complete} alt="" />
            </div>
            <p>
            Thank you for completing the assessment for {assesmentAndLocation?.address ?? ""}.
            </p>
            <p className="mt-3">
            Your assessment has been successfully submitted. We appreciate your participation and look forward to sharing your results soon!
            </p>
            <div className="instruction__points submitted">
              <h4>What Happens Next?</h4>
              <ul>
                <li>
                FlexGrade will review your submission within 3 business days and confirm acceptance via email.
                </li>
                <li>
                Once accepted, grading will be completed within another 3 business days, and you'll receive your badges and scoring report via email. 
                </li>
              </ul>
              <h4>Additional Assessments</h4>
              <ul>
                <li>
                If you have other pending locations, click the <span><Link to={"/location"}>Main Page</Link></span> (top left) to access them.
                </li>
              </ul>
              <h4>Need Assistance?</h4>
              <ul>
                <li>
                Visit the <span><button onClick={showInstruction}>Instruction Page</button></span> (left navigation) or email us at <a href="mailto:info@flexgrade.io">info@flexgrade.io</a>.
                </li>
              </ul>
            </div>
          </>
        </div>
        : <div className="instructions__section">
          {isAllRequiredFilled ? (
            <>
              <p>
                The following required question(s) are missing an answer. Please
                click on each one below to go directly to it, or use the left
                navigation bar to find them highlighted in red.
              </p>
              <div className="unanaswered__ques">
                <ul>
                  {(isSolelyManaged ? unansweredQuestions?.filter(item => !item?.isExcluded):unansweredQuestions)?.sort((a, b) => a.category_sorted_refCode - b.category_sorted_refCode)?.map((v, i) => {
                    return (
                      <li>
                        <button onClick={() => handleSelect(v?.refCode)} key={i}>
                          {formatQuesNumber(v?.refCode)}.{" "}
                          {v?.criteria}
                        </button>
                      </li>
                    );
                  })}
                </ul>
              </div>
              <div className="instruction__points">
                <ul>
                  <li>
                    Once all required questions are completed, return to this page
                    to submit the assessment.
                  </li>
                  <li>
                    The submission button will activate once all required fields
                    are answered, and the missing questions list above will
                    disappear.
                  </li>
                </ul>
              </div>
            </>
          ) : (
            <p className="instructions__section__answered__text">
              Great job! You've answered all the required questions. If you're
              ready to submit the assessment for this location, simply click the
              blue button to proceed.
            </p>
          )}
          <div className="next__and__skip">
            <button
              onClick={openModal}
              disabled={isAllRequiredFilled}
            >
              READY TO SUBMIT ASSESSMENT
            </button>
          </div>
        </div>}
      <SubmitFormPopup onHide={closeModal} show={showModal} handleNext={handleNext} />
    </div>
  );
};

export default ShowSubmit;
